<div class="text-input-wrapper">
    <input [type]="telType() ? 'tel': 'text'"
           [attr.id]="id()"
           class="text-input"
           [formControl]="inputControl()"
           [placeholder]="placeholder()"
           [maxLength]="maxLength()"
           [class.text-input-error]="isInvalid()" />
    @if (isInvalid()) {
        <img [ngSrc]="'/assets/img/icons/red-alarm.svg'" class="alarm-icon"
             width="16" height="16" alt=""/>
        <div class="error-text-wrapper">
            @if (inputControl().errors?.['required']) {
                <div>{{ subtitles.setSubtitle(5062) }}</div>
            }
            @if (inputControl().errors?.['maxlength']) {
                <div>{{ subtitles.setSubtitle(8652) }}</div>
            }
        </div>
    }
</div>
